import { useSelector } from "react-redux";


const CouponCode = () => {
  const OrgId = useSelector((state) => state.auth.org_id)
  // console.log(OrgId, 'org_id__________')
  
  return (
    <div className="iframe-div">
        {/* <iframe title="htFrame" src= {`https://iipl.retool.com/embedded/public/a75b2213-6ee5-405e-82c6-faff9ab1c4a0`}
        className="iframe-style"></iframe> */}
        <iframe src= {`https://iiplwork.retool.com/embedded/public/bc0ddc78-1d3f-4ce3-a9ed-c04e5f14da46`}
        className="iframe-style"></iframe>
    </div>
  )
};

export default CouponCode;
